import { Navigate } from "react-router-dom";
import FinancialManagerNav from "../../pages/Dashboard/Finance/FinancialManagerNav";
import FinanceIndex from "../../pages/Dashboard/Finance/FinanceIndex";
import Payroll from "../../pages/Dashboard/Finance/Payroll/Payroll";
import Advance from "../../pages/Dashboard/Finance/Advance/Advance";
import Bonus from "../../pages/Dashboard/Finance/Bonus/Bonus";
import MedicinePayment from "../../pages/Dashboard/Finance/MedicinePayment/MedicinePayment";
import MedicinePaymentList from "../../pages/Dashboard/Finance/MedicinePayment/MedicinePaymentList";
import ExpensePayment from "../../pages/Dashboard/Finance/ExpensePayment/ExpensePayment";
import ExpensePaymentList from "../../pages/Dashboard/Finance/ExpensePayment/ExpensePaymentList";
import ManageExpensesType from "../../pages/Dashboard/Finance/expensesType/ManageExpensesType";
import ListExpenseSource from "../../pages/Dashboard/Finance/ExpenseSource/ListExpenseSource/ListExpenseSource";
import AddExpenseSource from "../../pages/Dashboard/Finance/ExpenseSource/AddExpenseSource/AddExpenseSource";
import ExpensesList from "../../pages/Dashboard/Finance/Expenses/ExpensesList";
import Expenses from "../../pages/Dashboard/Finance/Expenses/Expenses";
import InvoicesList from "../../pages/Dashboard/Finance/Invoices/InvoicesList";
import InvoiceDetail from "../../pages/Dashboard/Finance/Invoices/InvoiceDetail";
import AddInvoice from "../../pages/Dashboard/Finance/Invoices/AddInvoice";
import PaymentsList from "../../pages/Dashboard/Finance/Payments/PaymentsList";
import AddPayment from "../../pages/Dashboard/Finance/Payments/AddPayment";

const financialManagerRoutes = {
  path: "/financial-manager",
  element: <FinancialManagerNav />,
  children: [
    {
      path: "/financial-manager",
      element: <FinanceIndex />,
    },
    { path: "/financial-manager/payroll", element: <Payroll /> },
    { path: "/financial-manager/advance", element: <Advance /> },
    { path: "/financial-manager/bonus", element: <Bonus /> },
    {
      path: "/financial-manager/expenses-type",
      element: <ManageExpensesType />,
    },
    {
      path: "/financial-manager/expense-source",
      element: <ListExpenseSource />,
    },
    {
      path: "/financial-manager/expense-source/add",
      element: <AddExpenseSource />,
    },
    { path: "/financial-manager/expenses", element: <ExpensesList /> },
    { path: "/financial-manager/expenses/add", element: <Expenses /> },
    {
      path: "/financial-manager/expense-payments",
      element: <ExpensePaymentList />,
    },
    {
      path: "/financial-manager/expense-payments/add",
      element: <ExpensePayment />,
    },
    {
      path: "/financial-manager/medicine-payment",
      element: <MedicinePaymentList />,
    },
    {
      path: "/financial-manager/medicine-payment/add",
      element: <MedicinePayment />,
    },
    { path: "/financial-manager/invoices", element: <InvoicesList /> },
    { path: "/financial-manager/invoices/add", element: <AddInvoice /> },
    { path: "/financial-manager/invoices/:id", element: <InvoiceDetail /> },
    { path: "/financial-manager/payments", element: <PaymentsList /> },
    { path: "/financial-manager/payments/add", element: <AddPayment /> },
  ],
};

export default financialManagerRoutes;
